import { Dispatch, SetStateAction, FC } from "react";
import {
    Page,
    PaginationBar,
} from "../../../../../assets/components/PaginationBar/PaginationBar";
import TableHeader from "../../../../../assets/components/Table/TableHeader";

import { NotActivatedLicenseKey } from "../model";

interface Props {
    dataTable: NotActivatedLicenseKey[];
    pageNumber: Page;
    currentSizePage: number;
    sizePage: number;
    totalLicenses: number;
    setCurrentPage: Dispatch<SetStateAction<Page>>;
    triggerDownloadCSV: () => void;
}

const LicenseKeysNotActivatedTableHeader: FC<Props> = ({
    sizePage,
    currentSizePage,
    dataTable,
    pageNumber,
    totalLicenses,
    setCurrentPage,
    triggerDownloadCSV,
}) => {
    return (
        <TableHeader
            pageSize={currentSizePage}
            dataTableLength={dataTable.length}
            title="List of licenses"
            onDownloadFileHandler={triggerDownloadCSV}
        >
            <PaginationBar
                currentPage={pageNumber as number}
                currentPageHandler={setCurrentPage}
                totalItems={totalLicenses}
                pageSize={sizePage}
            />
        </TableHeader>
    );
};

export default LicenseKeysNotActivatedTableHeader;
